import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: 'img[appDefaultImage]',
})
export class DefaultImageDirective {
    @Input() appDefaultImage!: string;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    @HostListener('error', ['$event'])
    onError(event: Event) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', this.appDefaultImage);
    }
}
